
import { defineComponent } from 'vue'
import { mapState } from 'vuex'
import formatDateMixin from '@/utils/mixin'
import { isStandardDeliveryDate } from '@/utils/deliveryDate'
import AsahiButton from '@/components/library/AsahiButton.vue'
import shipToIcon from '@/components/library/assets/shipTo.svg'
import trackIcon from '@/components/library/assets/Truck.svg'
import CalendarIcon from '@/assets/icons/calendar-white.svg'
import AsahiTypography from '@/components/library/Typography.vue'
import closebadge from '@/assets/icons/library/closebadge.svg'

export default defineComponent({
  name: 'ContinueShopping',

  loadingIndicators: true,

  components: {
    AsahiButton,
    AsahiTypography
  },
  props: {
    closeModal: {
      type: Function,
      default: () => {
        /* */
      }
    },
    isShipping: {
      type: Boolean,
      default: false
    }
  },

  mixins: [formatDateMixin],

  inject: ['isPeroni'],

  data () {
    return {
      continueValue: 'continue',
      newValue: 'new',
      shipToIcon,
      trackIcon,
      CalendarIcon,
      deliveryDateSelected: '',
      selectedValue: 'continue',
      closebadge
    }
  },

  emits: ['doSelection'],

  computed: {
    ...mapState('basket', ['query', 'items', 'id']),
    ...mapState('catalog', ['shipTos', 'continueModalTitle', 'continueModalSubTitle', 'continueModalContinueMessage', 'continueModalNewMessage']),

    shipToName () {
      const { permissionSchema = [] } = this.$store.state.auth.user || {}
      return permissionSchema.find((permission: any) => permission.shipToId === this.query?.ship_to_id)?.shipToName
    }
  },

  methods: {
    async startYourOrder () {
      this.$nextTick(async () => {
        localStorage.setItem('deliveryDate', this.query.delivery_date)

        localStorage.setItem('shippingMethod', this.query.delivery_method)

        if (this.query.note_for_driver != null) localStorage.setItem('noteForDriver', this.query.note_for_driver)
        if (this.query.customer_order_number != null) {
          localStorage.setItem('customerOrderNumber', this.query.customer_order_number)
        }
        this.$emit('doSelection')
        this.closeModal()
        this.fetchProducts()
      })
    },

    async fetchProducts () {
      try {
        await this.$store.dispatch('catalog/FETCH_PRODUCTS', {}, { root: true })
      } catch (error) {
        console.error(error)
      }
    },

    async removeItemInner (id: string) {
      await this.$store.dispatch('basket/REMOVE_ITEM', { cart_id: this.id, cart_item_id: id }, { root: true })
    },

    async cancel () {
      await this.$store.dispatch('basket/REMOVE_ALL_ITEMS', { cart_id: this.id }, { root: true })
      await this.$store.dispatch('basket/FETCH_CART_QUERY', { cart_id: this.id }, { root: true })
      this.$emit('doSelection')
      this.closeModal()
    },

    select (value: string) {
      this.selectedValue = value
    },

    isSelected (value:string) {
      return this.selectedValue === value
    },

    proceed () {
      if (this.selectedValue === this.continueValue) {
        this.startYourOrder()
      } else {
        this.cancel()
      }
    }
  }
})
